<div class="sort-selector w-100">
  <form (submit)="formSubmitted()" class="d-flex w-100 align-items-center">
    <label for="sortSelector" class="text-nowrap">{{ 'sort_by' | translate }}</label>
    <select id="sortSelector" [(ngModel)]="sortValue" class="margin-left-xs w-100" [ngModelOptions]="{ standalone: true }">
      @for (item of sortItems; track $index) {
        <option [ngValue]="item.value">{{ item.name }}</option>
      }
    </select>
    <button type="submit" class="btn btn-outline-primary fw-bold margin-left-xs">{{ 'label_sort' | translate }}</button>
  </form>
</div>
